import { useState } from 'react';
import jpMoment from 'moment';
import PropTypes from 'prop-types';
import laroute from '@/shared/laroute';
import ModalButton from '@/user/components/fair/reserve_button';

const _routeParams = (fairId, date, startTime = null) => {
    const routeParams = {
        fair_id: fairId,
    }
    if (date) {
        routeParams.fair_date = date;
    }
    if (startTime) {
        routeParams.fair_time = startTime;
    }

    return routeParams;
}

function TimeList({ times, date, showLink, fairId }) {
    const [selectedTime, setSelectedTime] = useState(null);
    const [reserveLink, setReserveLink] = useState(laroute.route('user.reservation.create', _routeParams(fairId, date)));

    const handleChange = (event) => {
        const index = parseInt(event.target.value, 10);
        setSelectedTime(index);
        const startTime = jpMoment(times[index].start_time, 'HH:mm:ss').format('HH:mm');

        const reserveUrl = laroute.route('user.reservation.create', _routeParams(fairId, date, startTime)); // クエリストリングがつくので末尾に / を入れない
        setReserveLink(reserveUrl);
    };

    // 開催時間全てが満席であるかチェック
    const isFullReserveReminder = (times) => {
        return times.every(time => time.remainder === '2');
    }

    const timeDom = times.map((time, i) => {
        let labelClass = "border-color--text-before::before background-color font-family--middle";
        let remindType = "icon_round fair-result-schedule__symbol--accepting border-color--text-before::before";
        const isTargetTime = selectedTime === i;
        const isChecked = time.remainder === '2' || false;

        if (time.remainder === '1') {
            remindType = "fair-result-schedule__symbol--few is-few";
        } else if (time.remainder === '2') {
            labelClass = "color--sub_text border-color--contents_bg background-color--contents_bg font-family--middle";
            remindType = "fair-result-schedule__symbol--full color--text is-full";
        }

        const startTime = jpMoment(time.start_time, 'HH:mm:ss').format('HH:mm');
        const endTime = time.end_time ? jpMoment(time.end_time, 'HH:mm:ss').format('HH:mm') : '';

        if (isTargetTime) {
            labelClass = "border-color--sub background-color--sub font-family--middle";
        }

        return (
            <li className="fair-search-reserve__list" key={i}>
                <input
                    id={`fair_time_${i}`}
                    className="fair_time"
                    type="radio"
                    value={i}
                    onChange={handleChange}
                    checked={isTargetTime}
                    disabled={isChecked}
                />
                <label htmlFor={`fair_time_${i}`} className={labelClass}>
                    <span className="fair-search-reserve__time">{startTime}~<br />{endTime}</span>
                    <span className={remindType}></span>
                </label>
            </li>
        );
    });

    return (
        <>
            <ul className="fair-search-reserve__type">
                {timeDom}
            </ul>
            <ModalButton
                reserveLink={reserveLink}
                showLink={showLink}
                canReserve={! isFullReserveReminder(times)}
            />
        </>
    );
}

/**
 * times: 開催時間一覧
 * date: 選択した日付(YYYY-mm-dd)
 * showLink: フェア詳細のURL
 * fairId: フェアID
 */
TimeList.propTypes = {
    times: PropTypes.array.isRequired,
    date: PropTypes.string.isRequired,
    showLink: PropTypes.string.isRequired,
    fairId: PropTypes.string.isRequired,
};

export default TimeList;
